import React, { FunctionComponent } from 'react'
import { Row } from '@paypalcorp/pp-react'

import CircularIcon from './CircularIcon'
import { RelatedResource } from '../utils/common'

const iconsMap: any = {
  key: null,
  shovel: null,
  creditcard: null,
  terminal: null,
  terminalsettings: null,
}

interface RelatedResourcesProps {
  resources: RelatedResource[]
}

export const RelatedResources: FunctionComponent<RelatedResourcesProps> = ({
  resources,
}) =>
  resources?.length ? (
    <Row style={{ display: 'flex', flexDirection: 'column' }}>
      <h2>Related Resources</h2>
      {resources.map(({ icon, label, url }, i) => {
        const IconComponent = icon ? iconsMap[icon] : null

        return (
          <div key={i} className="relatedResourceRowItem">
            <CircularIcon url={url} Icon={IconComponent} />
            <a href={url}>{label}</a>
          </div>
        )
      })}
    </Row>
  ) : null
